module.exports = __webpack_public_path__ + "media/images/reseller-5e80e2b8197a955e06dc8b7c00adfe47.jpg";